import * as actionTypes from "./actionTypes";
import { appLoading, appRedirect, appSuccess, appError, appSuccessMessage } from "./appActions";
import { toastr } from "react-redux-toastr";
import { logoutUser } from "./authActions";
import {
  downloadContractApi,
  createContractWithoutCertificateApi,
  downloadGuaranteesTableApi,
  getPublicKeyHealthMobility,
  listCountriesApi,
  getPublicKeyMultimedia,
  getListPublicKeyMultimedia,
  createContractForMultimediaInsurance, finishMultimediaDigitalFirmApi, redirectHealthMutualInsurance, finishHealthMobilityDigitalFirmApi,
  createFrenchZoneHealthMobilityApi,
} from "../../api/InsuranceApi";
import fileDownload from "js-file-download";
import LocalStorageService from "../../services/LocalStorageService";
import { delay } from "../../helpers/delay";
import { markReferralDiscountUsed } from "./UserActions";
import { trackEvent } from "../../utils/trackEvent";

export const listCountriesSuccess = (data) => ({
  type: actionTypes.LIST_COUNTRIES_SUCCESS,
  payload: data,
});

export const listCountriesFailed = (error) => ({
  type: actionTypes.LIST_COUNTRIES_FAILED,
  payload: error,
});

export const listPriceSuccess = (data) => ({
  type: actionTypes.LIST_PRICE_SUCCESS,
  payload: data,
});

export const listPriceFailed = (error) => ({
  type: actionTypes.LIST_PRICE_FAILED,
  payload: error,
});

export const downloadContractSuccess = (data) => ({
  type: actionTypes.DOWNLOAD_CONTRACT_FILE_SUCCESS,
  payload: data,
});

export const downloadContractFailed = (error) => ({
  type: actionTypes.DOWNLOAD_CONTRACT_FILE_FAILED,
  payload: error,
});

export const downloadGuaranteesTableSuccess = (data) => ({
  type: actionTypes.DOWNLOAD_GUARANTEES_TABLE_SUCCESS,
  payload: data,
});

export const downloadGuaranteesTableFailed = (error) => ({
  type: actionTypes.DOWNLOAD_GUARANTEES_TABLE_FAILED,
  payload: error,
});

export const detailByCountryAndRageDateSuccess = (data) => ({
  type: actionTypes.DETAIL_BY_COUNTRY_AND_RAGE_DATE_HEALTH_MOBILITY_SUCCESS,
  payload: data,
});

export const detailByCountryAndRageDateFailed = (error) => ({
  type: actionTypes.DETAIL_BY_COUNTRY_AND_RAGE_DATE_HEALTH_MOBILITY_FAILED,
  payload: error,
});

export const detailMultimediaSuccess = (data) => ({
  type: actionTypes.DETAIL_MULTIMEDIA_SUCCESS,
  payload: data,
});

export const cleanDetailMultimediaSuccess = () => ({
  type: actionTypes.DETAIL_MULTIMEDIA_SUCCESS,
  payload: null,
});



export const createContractForMultimediaInsuranceSuccess = (data) => ({
  type: actionTypes.CREATE_CONTRACT_MULTIMEDIA_INSURANCE_SUCCESS,
  payload: data,
});

export const createContractForMultimediaInsuranceFailed = (data) => ({
  type: actionTypes.CREATE_CONTRACT_MULTIMEDIA_INSURANCE_FAILED,
  payload: data,
});

export const createContractForHealthInsuranceSuccess = (data) => ({
  type: actionTypes.CREATE_CONTRACT_HEALTH_MOBILITY_INSURANCE_SUCCESS,
  payload: data,
})

export const createContractForHealthInsuranceFailed = (data) => ({
  type: actionTypes.CREATE_CONTRACT_HEALTH_MOBILITY_INSURANCE_FAILED,
  payload: data,
})

export const listCountries = () => (dispatch) => {
  dispatch(appLoading());
  listCountriesApi()
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      dispatch(listCountriesSuccess(data));
    })
    .catch((error) => {
      dispatch(listCountriesFailed(error));
      dispatch(appError());
      if (error && error.response && error.response.data) {
        console.log("Error: ", error.response.data.message);
      } else {
        console.log("Error: ", "error connected to server");
      }
      toastr.error("ERROR", error.message);
      dispatch(logoutUser());
    });
};

export const downloadContract = (payload) => (dispatch) => {
  const { params, history } = payload;
  dispatch(appLoading());
  downloadContractApi(params)
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      dispatch(downloadContractSuccess(data));
      fileDownload(data, "AttestationSantéMobilité.pdf");
      toastr.success("INFO", "Vous venez de recevoir votre attestation sur votre adresse mail et dans votre rubrique mes documents");
    })
    .catch((error) => {
      dispatch(downloadContractFailed(error));
      dispatch(appError());
      if (error && error.response && error.response.data) {
        console.log("Error: ", error.response.data.message);
      } else {
        console.log("Error: ", "error connected to server");
      }
      toastr.error("ERROR", error.message);
    });
};

export const createContractWithoutCertificate = (payload) => async (dispatch) => {
  const { history, params } = payload;
  dispatch(appRedirect());

  try {
    const response = await createContractWithoutCertificateApi(params);

    let data;

    if (response instanceof Blob) {
      const text = await response.text();
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("❌ Erreur de parsing JSON depuis Blob :", e);
        return;
      }
    } else if (response.data) {
      data = response.data;
    } else {
      console.error("❌ Format de réponse inattendu :", response);
      return;
    }

    console.log("✅ Données reçues :", data);

    // ✅ Intégration du tracking GTM ici
    const { startDate, endDate, country, healthMobilityPrime, sessionStripe } = params;
    const service = LocalStorageService.getService();
    const currentUser = LocalStorageService.getUser();

    trackEvent('purchase', {
      ecommerce: {
        value: healthMobilityPrime,
        currency: 'EUR',
        payment_type: 'card',
        items: [{
          item_category: 'Santé Mobilité',
          price: healthMobilityPrime,
          quantity: 1
        }]
      },
      user_data: {
        email: currentUser.email,
        first_name: currentUser.name,
        last_name: currentUser.lastName,
        roles: currentUser.roles,
        school: currentUser.school
      },
      contract_info: {
        contract_id: data.contractId,
        customer_number: data.customerNumber,
        session_stripe: sessionStripe,
        country: country.name,
        start_date: startDate,
        end_date: endDate
      }
    });

    const url = data?.link;
    if (!url) {
      console.error("❌ URL manquante dans la réponse :", data);
      return;
    }

    if (data.user?.hasUsedReferralDiscount && !!data.user?.referredBy) {
      dispatch(markReferralDiscountUsed());
    }

    let healthMobilityContract = service.getHealthMobilityContract() || {};
    healthMobilityContract = { ...healthMobilityContract, ...data };
    service.setHealthMobilityContract(healthMobilityContract);

    dispatch(appSuccess());

    window.location.href = url;

  } catch (error) {
    dispatch(appError());
    if (error?.response?.data?.message) {
      console.error("Erreur backend :", error.response.data.message);
      toastr.error("ERROR", error.response.data.message);
    } else {
      console.error("Erreur inconnue :", error);
      toastr.error("ERROR", "Une erreur est survenue.");
    }
  }
};




export const createFrenchZoneHealthMobility = (payload) => (dispatch) => {
  const { history, params } = payload;
  dispatch(appRedirect());
  createFrenchZoneHealthMobilityApi(params)
    .then( async (response) => {
      const { data } = response;
      dispatch(appSuccessMessage("Once you have registered, you will find your certificate in your documents area."));
      await delay(3000);
      dispatch(appSuccess());
      history.push("/documents");
      if (!params.sessionStripe) {
        throw new Error("La variable sessionStripe n'est pas définie dans les paramètres.");
      }
    })
    .catch((error) => {
      dispatch(appError());
      if (error && error.response && error.response.data) {
        console.log("Error: ", error.response.data.message);
      } else {
        console.log("Error: ", "error connected to server");
      }
      toastr.error("ERROR", error.message);
    });
};




export const downloadGuaranteesTable = () => (dispatch) => {
  dispatch(appLoading());
  downloadGuaranteesTableApi()
    .then((response) => {
      const { data } = response;
      dispatch(appSuccess());
      dispatch(downloadGuaranteesTableSuccess(data));
      fileDownload(data, "TableauDeGaranties.pdf");
    })
    .catch((error) => {
      dispatch(downloadGuaranteesTableFailed(error));
      dispatch(appError());
      if (error && error.response && error.response.data) {
        console.log("Error: ", error.response.data.message);
      } else {
        console.log("Error: ", "error connected to server");
      }
      toastr.error("ERROR", error.message);
    });
};

export const getPublicKey = (payload) => (dispatch) => {
  const { zone, month, partnerLevelHealthMobilityPrice, history } = payload;
  console.log("Payload", payload)
  dispatch(appLoading());

  getPublicKeyHealthMobility(zone, month, partnerLevelHealthMobilityPrice)
    .then((response) => {
      const { data } = response;
      const dataDetails = data.data;

      dispatch(appSuccess());
      dispatch(detailByCountryAndRageDateSuccess(dataDetails));
    })
    .catch((error) => {
      dispatch(detailByCountryAndRageDateFailed(error));
      dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error('ERROR', 'Une erreur est survenue lors de la connexion au serveur.');
        console.log('Error: ', 'error connected to server');
      }
    });
};


export const getPriceMultimediaInsurance = (payload) => (dispatch) => {
  const { price, condition, school, history } = payload;
  dispatch(appLoading());

  getPublicKeyMultimedia(price, condition, school)
    .then((response) => {
      const { data } = response;
      console.log("response");
      console.log(response);
      const dataDetails = data.data;
      dispatch(appSuccess());
      dispatch(detailByCountryAndRageDateSuccess(dataDetails));
    })
    .catch((error) => {
      dispatch(detailByCountryAndRageDateFailed(error));
      dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error('ERROR', 'Une erreur est survenue lors de la connexion au serveur.');
        console.log('Error: ', 'error connected to server');
      }
    });
};

export const getListPriceMultimediaInsurance = (payload) => (dispatch) => {
  const { type, school, recurring, history } = payload;
  dispatch(appLoading());

  getListPublicKeyMultimedia(type, school, recurring)
    .then((response) => {
      dispatch(appSuccess());
      const { data } = response;
      const dataDetails = data.data;
      dispatch(listPriceSuccess({ data: dataDetails.stripe }));
    })
    .catch((error) => {
      dispatch(listPriceFailed(error));
      if (error && error.response && error.response.data) {
        dispatch(appError());
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error('ERROR', 'Une erreur est survenue lors de la connexion au serveur.');
        console.log('Error: ', 'error connected to server');
      }
    });
};





export const createMultimediaInsuranceContractApi = (payload) => (dispatch) => {
  const { data, history } = payload;
  dispatch(appRedirect());
  const service = LocalStorageService.getService();
  createContractForMultimediaInsurance(data)
    .then((response) => {
      const { data } = response;
      dispatch(createContractForMultimediaInsuranceSuccess(data));
      //debugger
      let multimediaContractService = service.getMultimediaContract();
      multimediaContractService = { ...multimediaContractService, ...data }
      service.setMultimediaContract(multimediaContractService);
      const errorUrl = window.location.origin + "/home/";
      const successUrl = window.location.origin + "/insurance/sign?context=multimedia";
      const url = "https://cloud.sellandsign.com/calinda/sellandsign/#/contract/" + multimediaContractService.contractId + "/sign;c_id=" + multimediaContractService.contractId + ";no_ui=true;refback=" + encodeURIComponent(successUrl) + ";errorback=" + encodeURIComponent(errorUrl) + ";j_token=" + encodeURIComponent(multimediaContractService.token);
      dispatch(appSuccess());
      window.location.href = url;

    })
    .catch((error) => {
      createContractForMultimediaInsuranceFailed(error);
      dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error("ERROR", "Une erreur est survenue lors de la connexion au serveur");
        console.log("Error: ", "error connected to server");
      }
    })
};

export const finishMultimediaDigitalFirm = (payload) => (dispatch) => {
  const { fields, history } = payload;
  dispatch(appRedirect());
  finishMultimediaDigitalFirmApi(fields)
    .then((response) => {
      const { data } = response;
      const service = LocalStorageService.getService();
      service.removeMultimediaContract();
      dispatch(appSuccess());
      history.push('/documents');

    })
    .catch((error) => {
      //dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error("ERROR", "Une erreur est survenue lors de la connexion au serveur");
        console.log("Error: ", "error connected to server");
      }
    })
};

export const finishHealthMobilityDigitalFirm = (payload) => (dispatch) => {
  const { fields, history } = payload;
  dispatch(appRedirect());
  finishHealthMobilityDigitalFirmApi(fields)
    .then((response) => {
      const { data } = response;
      const service = LocalStorageService.getService();
      service.removeMultimediaContract();
      dispatch(appSuccess());
      history.push('/documents');

    })
    .catch((error) => {
      dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error("ERROR", "Une erreur est survenue lors de la connexion au serveur");
        console.log("Error: ", "error connected to server");
      }
    })
};


export const redirectHealthMutualContractApi = (payload) => (dispatch) => {
  const { history } = payload;
  dispatch(appRedirect());
  redirectHealthMutualInsurance()
    .then((response) => {
      const { data } = response;
      const url = data.url;
      dispatch(appSuccess());
      window.location.href = url;
    })
    .catch((error) => {
      dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error("ERROR", "Une erreur est survenue lors de la connexion au serveur");
        console.log("Error: ", "error connected to server");
      }
      history.push('/home');
    })
};

